<span 
    class="tooltiptext"
    [ngClass]="tooltipPosition"
>{{ tooltipText }}</span>
<ng-content></ng-content>